<ng-container *ngIf="_xeroContractOptions">
    <h4>Xero</h4>

    <app-input-text label="Department Code"
        [(ngModel)]="_xeroContractOptions.department_code"
        (change)="onModelChanged($event)" />

    <app-input-text
        [(ngModel)]="_xeroContractOptions.inventory_item_code"
        label="Inventory Item Code (optional)"
        (change)="onModelChanged($event)" />
</ng-container>
